import { useEffect, useState } from 'react';
import AuthRequiredPanel from './components/auth/AuthRequiredPanel';
import SiteFooter from './components/layout/SiteFooter';
import DesktopHeader from './components/navigation/DesktopHeader';
import MobileTabBar from './components/navigation/MobileTabBar';
import Seo from './components/seo/Seo';
import { useCurrentPath } from './hooks/useCurrentPath';
import CommunityPage from './pages/CommunityPage';
import HorseClubPage from './pages/HorseClubPage';
import HomePage from './pages/HomePage';
import IntroLanding from './pages/IntroLanding';
import KraCitizenEventPage from './pages/KraCitizenEventPage';
import MyInfoPage from './pages/MyInfoPage';
import NewsPage from './pages/NewsPage';
import PartnersPage from './pages/PartnersPage';
import ServicesPage from './pages/ServicesPage';
import SupportPage from './pages/SupportPage';
import { routeMap, routes } from './routes/routes';
import './App.css';

const pageComponents = {
  home: HomePage,
  horseClub: HorseClubPage,
  services: ServicesPage,
  news: NewsPage,
  community: CommunityPage,
  partners: PartnersPage,
  support: SupportPage,
  myInfo: MyInfoPage,
};

function App() {
  const currentPath = useCurrentPath();
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'auto' });
  }, [currentPath]);

  if (currentPath === routes.intro) {
    return (
      <>
        <Seo path={currentPath} />
        <IntroLanding />
      </>
    );
  }

  if (currentPath === routes.kraCitizenEvent) {
    return (
      <>
        <Seo path={currentPath} />
        <KraCitizenEventPage />
      </>
    );
  }

  const activeItem = routeMap[currentPath] ?? routeMap[routes.home];
  const ActivePage = pageComponents[activeItem.id] || HomePage;
  const canViewActivePage = !activeItem.authRequired || isAuthenticated;

  return (
    <div className="app-shell">
      <Seo path={currentPath} />

      <DesktopHeader
        activePath={activeItem.path}
        isAuthenticated={isAuthenticated}
        onAuthToggle={() => setIsAuthenticated((current) => !current)}
      />

      <main className="app-main">
        {canViewActivePage ? (
          <ActivePage isAuthenticated={isAuthenticated} />
        ) : (
          <AuthRequiredPanel
            pageLabel={activeItem.label}
            onLogin={() => setIsAuthenticated(true)}
          />
        )}
      </main>

      <SiteFooter />

      <MobileTabBar activePath={activeItem.path} />
    </div>
  );
}

export default App;
